import { combineReducers } from 'redux';


 import  {reducer as VoucherPortalFormReducer}  from "./voucherPortalFormReducer"


const rootReducer = combineReducers({

  VoucherPortalFormReducer

  // Add other reducers here
});
export default rootReducer;

